import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';
import { PaymentsListFilterDialogComponent } from './payments-list-filter-dialog.component';

@NgModule({
  declarations: [PaymentsListFilterDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    WsUiModule,
  ],
  exports: [PaymentsListFilterDialogComponent],
})
export class PaymentsListFilterDialogModule {}
